import snakecaseKeys from 'snakecase-keys';
import { restClient } from '../client';
import { BusinessEntity, InsuranceCompany, License, MentalHealthRole, ProviderInsuranceRosterStatusEnum } from '../resources';


export const getProviderLicenses = (providerId: string) => restClient.request<{
  data: License[];
}>(`/api/v1/provider/${providerId}/license`);


export type CreateProviderLicenseInput = {
  expiration: string;
  number: string;
  stateId: string;
  mentalHealthRoleId: string;
};


export enum ProviderInsuranceArchiveReason {
  addedByMistake = 'added_by_mistake',
  noLongerInNetwork = 'no_longer_in_network',
}


export const createProviderLicense = (providerId: string, data: CreateProviderLicenseInput) => restClient.request<{
  data: License;
}>(`/api/v1/provider/${providerId}/license`, {
  method: 'POST',
  data: snakecaseKeys(data),
});


export const getProviderMissingPayers = (providerId: string) => restClient.request<{
  data: Record<string, InsuranceCompany[]>;
}>(`/api/v1/provider/${providerId}/missing_payers`);


export type UpdateProviderLicenseInput = {
  expiration: string;
  number: string;
  stateId: string;
  mentalHealthRoleId: string;
};


export const getMentalHealthRoles = () => restClient.request<{
  data: MentalHealthRole[];
}>('/api/v1/mental_health_roles');


export const getProviderInsuranceExistingBusinessEntities = (providerId: string, licenseId: string, insuranceCompanyId: string) => restClient.request<{
  data: BusinessEntity[];
}>(`/api/v1/provider/${providerId}/license/${licenseId}/${insuranceCompanyId}/existing_business_entities`);


export const getProviderInsuranceAvailableBusinessEntities = (providerId: string, licenseId: string, insuranceCompanyId: string) => restClient.request<{
  data: BusinessEntity[];
}>(`/api/v1/provider/${providerId}/license/${licenseId}/${insuranceCompanyId}/available_business_entities`);


export const addProviderInsuranceBusinessEntity = (providerId: string, licenseId: string, insuranceCompanyId: string, businessEntities: {
  businessEntityId: string;
  effectiveDate?: string;
  rosterStatus: ProviderInsuranceRosterStatusEnum | null;
}[]) => restClient.request<{
  data: License;
}>(`/api/v1/provider/${providerId}/license/${licenseId}/${insuranceCompanyId}/business_entity`, {
  method: 'POST',
  data: {
    business_entities: snakecaseKeys(businessEntities)
  },
});


export const removeProviderInsuranceBusinessEntity = (providerId: string, licenseId: string, insuranceCompanyId: string, businessEntityId: string, archiveReason: ProviderInsuranceArchiveReason) => restClient.request<{
  data: License;
}>(`/api/v1/provider/${providerId}/license/${licenseId}/${insuranceCompanyId}/business_entity`, {
  method: 'DELETE',
  data: {
    business_entity_id: businessEntityId,
    archive_reason: archiveReason,
  },
});
